import axios from 'axios';

import createUrlWithParams from 'services/common/createUrlWithParams/createUrlWithParams';

import { DefaultApiResponse } from '../_types';
import { parseChoicesWithCountForUI } from './choices.parsers';
import type {
  ChoiceWithCount,
  ChoicesWithCountDto,
  CurriculumChoicesQuery,
  IsDoneChoicesQuery,
  MarkChoicesQuery,
} from './choices.types';

const endpoints = {
  curriculum: 'exercises/choices/curriculum/',
  mark: 'exercises/choices/mark/',
  isDone: 'exercises/choices/is_done/',
};

type GetChoicesQuery = () => Promise<ChoiceWithCount[]>;

const toScalarParams = (query: {
  subject: number;
  section?: number | null;
  subsection?: number | null;
  clientContext?: string | null;
}) => ({
  subject: query.subject,
  section: query.section ?? undefined,
  subsection: query.subsection ?? undefined,
  client_context: query.clientContext ?? undefined,
});

const exerciseChoicesApi = {
  getCurriculum:
    (query: CurriculumChoicesQuery): GetChoicesQuery =>
    async () => {
      const response = await axios.get<GetChoicesQuery, DefaultApiResponse<ChoicesWithCountDto>>(
        createUrlWithParams(endpoints.curriculum, toScalarParams(query)),
      );
      return parseChoicesWithCountForUI(response.data);
    },

  getMark:
    (query: MarkChoicesQuery): GetChoicesQuery =>
    async () => {
      const { curriculum, ...rest } = query;
      const response = await axios.get<GetChoicesQuery, DefaultApiResponse<ChoicesWithCountDto>>(
        createUrlWithParams(
          endpoints.mark,
          toScalarParams(rest),
          curriculum?.length ? { array: curriculum, paramKey: 'curriculum' } : undefined,
        ),
      );
      return parseChoicesWithCountForUI(response.data);
    },

  getIsDone:
    (query: IsDoneChoicesQuery): GetChoicesQuery =>
    async () => {
      const { curriculum, ...rest } = query;
      const response = await axios.get<GetChoicesQuery, DefaultApiResponse<ChoicesWithCountDto>>(
        createUrlWithParams(
          endpoints.isDone,
          toScalarParams(rest),
          curriculum?.length ? { array: curriculum, paramKey: 'curriculum' } : undefined,
        ),
      );
      return parseChoicesWithCountForUI(response.data);
    },
};

export default exerciseChoicesApi;
